<template>
	<div class="reviews" v-if="insertVideoReviews">
		<div ref="sliderEl" class="reviews-slider" :data-uno-dos-trends-uuid="insertVideoReviews"></div>
	</div>
</template>

<script>
export default {
  props: {
  	tourId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      timerId: null,
      reviewsLoaded: false,
      toursReviews: {
      	"23607": "389d2b20-f3a8-4bd4-a119-4ecc2d1eb557",
      	"38641": "5e892854-e2b4-475b-9ece-645d022ddd75",
      	"36569": "ec00abab-9a65-4858-b0f2-b72868e67ed5",
      	"42301": "e5f0e040-96b2-46a7-97d0-46fb29ca99a7",
      	"42425": "638d5d3b-aacc-46e3-ad11-c6d80ab480da",
      	"12255": "e17424b6-a1e9-4f9f-aef8-7cec7a338579",
      	"42191": "6d2a3f4c-7721-4942-8589-10dab2d20e6a",
      	"37843": "7368d7a9-fa5c-457f-87ad-024be95098e4",
      	"28214": "d0413188-5f46-4dbe-ba6f-7a0576d5fb5f",
      	"28151": "927fcc00-6ef1-49c4-856c-03bb56390b23",
      },
    };
  },
  mounted() {
    if (this.insertVideoReviews !== false) {
      this.pollReviewsReady();
    }
  },
  computed: {
    insertVideoReviews() {
      if (typeof this.toursReviews[this.tourId] === "undefined") {
        return false;
      }

      return this.toursReviews[this.tourId];
    },    
  },
  methods: {
    pollReviewsReady() {
      this.timerId = setInterval(() => {
        if (this.$refs.sliderEl.childNodes.length) {
          clearInterval(this.timerId);
          this.reviewsLoaded = true;
        }
      }, 100);
    },
  },
};
</script>
